

exports.__esModule = true;
exports.$xoOnboardingSectionComponent = undefined;

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

require('../guestThrottle');

require('xo-wallet-components/src/fi-logos/directive');

var _squid = require('squid');

var _paypalplus = require('../paypalplus');

var _index = require('xo-models/src/credit/index');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoOnboardingSectionComponent = exports.$xoOnboardingSectionComponent = _squid.$Component.extend('$xoOnboardingSectionComponent', {
    tag: 'xo-onboarding-section',
    template: _template2['default'],
    scope: {
        token: '=',
        guestVariant: '='
    },

    controller: function controller($scope, $guestThrottle, $locale, $populate, $FlowEligibilityModel, $feature, $CheckoutAppDataModel, $state) {

        function throttleOnboardingFlow(flow) {
            return $guestThrottle(flow, $scope.token, $locale.lang, $locale.country);
        }

        $scope.signupThrottle = function () {
            if ($scope.forceCAPESignup) {
                $state.go('checkout.redirectToCape');
            } else {
                throttleOnboardingFlow('signup');
            }
        };

        $scope.guestThrottle = function () {
            throttleOnboardingFlow('guest');
        };

        function getFlowEligibility() {
            return $FlowEligibilityModel.instance($scope.token).reload({
                params: {
                    'localeCountry': $locale.country
                }
            }).then(function (flowEligibility) {
                $scope.flowEligibility = flowEligibility;
            });
        }

        $populate($scope, {
            checkoutAppData: $CheckoutAppDataModel.instance($scope.token)
        }).then(function () {
            return getFlowEligibility();
        }).then(function () {
            $scope.creditDataModel = _index.$CreditDataModel.instance($scope.token);
            $scope.forceCAPESignup = $scope.checkoutAppData.is_second_button_txn && !$scope.creditDataModel.payInFull;
            var useForcedSignupFlow = (0, _paypalplus.$isPayPalPlus)($scope.token) || $scope.forceCAPESignup;
            var guest = $scope.flowEligibility.guest;
            var signup = $scope.flowEligibility.signup;

            $scope.showGuestBtn = !useForcedSignupFlow && guest;
            $scope.showSignupBtn = useForcedSignupFlow || !guest && signup;
            $scope.hideOrSeparator = !$scope.showGuestBtn && !$scope.showSignupBtn;
        });
    }
});

angular.value("$xoOnboardingSectionComponent", $xoOnboardingSectionComponent);
_squid.$Component;

_paypalplus.$isPayPalPlus;

_index.$CreditDataModel;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-login/onboarding/directive.js
// module id = ./pages/xo-login/onboarding/directive.js
// module chunks = 1